import React from 'react';
import { Chip } from '@mui/material';
import {
  CheckCircleOutlined as CheckCircleIcon,
  CancelOutlined,
  InfoOutlined as InfoIcon,
} from '@mui/icons-material';
import { useTheme, lighten } from '@mui/material/styles';
import {TimeIcon} from "@mui/x-date-pickers";

const opacity = 0.88;

const StatusChip = ({
  color,
  label,
  icon,
  size = 'small',
  className,
  sx,
  onClick,
  disabled = false,
}) => {
  const theme = useTheme();

  // Color configurations with appropriate colors
  const COLOR_CONFIGS = {
    info: {
      backgroundColor: lighten(theme.palette.info.main, opacity),
      textColor: theme.palette.info.main,
      defaultIcon: <InfoIcon fontSize="small" />,
    },
    error: {
      backgroundColor: lighten(theme.palette.error.main, opacity),
      textColor: theme.palette.error.main,
      defaultIcon: <CancelOutlined fontSize="small" />,
    },
    warning: {
      backgroundColor: lighten(theme.palette.warning.main, opacity),
      textColor: theme.palette.warning.main,
      defaultIcon: <TimeIcon fontSize="small" />,
    },
    success: {
      backgroundColor: lighten(theme.palette.success.main, opacity),
      textColor: theme.palette.success.main,
      defaultIcon: <CheckCircleIcon fontSize="small" />,
    },
    default: {
      backgroundColor: lighten(theme.palette.grey[500], opacity),
      textColor: theme.palette.grey[600],
      defaultIcon: <InfoIcon fontSize="small" />,
    },
  };

  // Get color configuration
  const config = COLOR_CONFIGS[color] || COLOR_CONFIGS.default;

  // Generate styles based on props
  const chipStyles = () => {
    const baseStyles = {
      backgroundColor: config.backgroundColor,
      color: config.textColor,
      fontWeight: 500,
      '& .MuiChip-label': {
        color: config.textColor,
      },
      '& .MuiChip-icon': {
        color: config.textColor,
      },
    };

    // Add large size styles
    if (size === 'large') {
      baseStyles.fontSize = '1.1rem';
      baseStyles.height = '36px';
      baseStyles['& .MuiChip-label'] = {
        ...baseStyles['& .MuiChip-label'],
        fontSize: '1.1rem',
        px: 2.5,
        py: 0.75,
      };
      baseStyles['& .MuiChip-icon'] = {
        ...baseStyles['& .MuiChip-icon'],
        fontSize: '1.2rem',
      };
    }

    return baseStyles;
  };

  return (
    <Chip
      label={label}
      icon={icon === 'none' ? undefined : icon || config.defaultIcon}
      size={size === 'large' ? 'medium' : size}
      variant={"filled"}
      className={className}
      onClick={onClick}
      disabled={disabled}
      sx={{
        ...chipStyles(),
        ...sx,
      }}
    />
  );
};

export default StatusChip;
